import { render, staticRenderFns } from "./FeedbackMessage.vue?vue&type=template&id=89544d64&"
import script from "./FeedbackMessage.vue?vue&type=script&lang=ts&"
export * from "./FeedbackMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports